import styled from 'styled-components';

export const InvestmentDetailsRowItemStyles = styled.div<{ $truncate?: boolean }>`
	display: flex;
	justify-content: space-between;
	border-top: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
	padding: 0.25rem 0.5rem;

	${({ $truncate }) =>
		$truncate
			? `
				gap: 0.5rem;
				min-width: 0;

				& > * {
					min-width: 0;
				}
			`
			: ''}

	&.no-border {
		border-top: none;
	}
`;
